import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import { HeaderExtraLarge600Style } from '../../../styles/Text.styles'

export const SectionTitle = styled.h1`
  ${HeaderExtraLarge600Style};
  line-height: 1.5rem;
  background-color: ${theme.colors.second}DA;
  color: ${theme.colors.textWhite};
  border-radius: 1.2rem;
  padding: 0.9rem 1.2rem;
  //margin-bottom: 1.0rem;
  //margin-top: 1.0rem;
  display: inline-block;
  min-width: 30%;
`
